<template>
  <div>
    <v-menu
      :nudge-right="right"
      :nudge-left="left"
      :nudge-bottom="bottom"
      :nudge-top="top"
      v-model="menu1"
      :close-on-content-click="false"
      max-width="290"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          dense
          :label="label"
          :clearable="clearable"
          v-facade="'##.##.####'"
          placeholder="30.03.2000"
          v-on="on"
          @keydown="menu1=false"
          :outlined="outlined"
          hide-details
          :value="value"
          @change="updateValue"
          :class="{ required: required }"
          @click:clear="date = null; updateValue('')"
          :disabled="disabled"
        ></v-text-field>
      </template>
      <v-date-picker
        locale="ru-RU"
        :first-day-of-week="1"
        v-model="date"
        @change="changeDate"
        :allowed-dates="allowed_dates"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  $_veeValidate: {
    name () {
      return this.label
    },
    value () {
      return this.value
    }
  },
  props: {
    value: String,
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    left: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    },
    bottom: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    allowed_dates: {
    },
  },
  data: function () {
    return {
      menu1: false,
      date: null
    }
  },
  methods: {
    changeDate (e) {
      this.menu1 = false
      this.updateValue(moment(e).format('DD.MM.YYYY'))
    },
    updateValue (e) {
      this.$emit('input', e)
    }
  }
}
</script>
<style>
</style>
